import { Box } from '@mui/material';
import React from 'react';
import TopLevelTemplateComponentProps, {
  TopLevelTemplateContentProps,
} from '../../models/TopLevelTemplateComponentProps';
import { ActionButtonProps } from '../ActionButton';
import FootnoteRenderer from '../FootnoteRenderer';
import { Palette } from 'Palette';
import StyledSection from '../styles/StyledSection';
import { StyledListWrapper } from '../styles/styles';
import LeftRightListHeadingBlock from './LeftRightListHeadingBlock';
import LeftRightListItemRow from './LeftRightListItemRow';
import { ListItem } from './leftRightListUtils';

export interface LeftRightListContent extends TopLevelTemplateContentProps {
  items: ListItem[];
  openSimplified?: boolean;
}

export interface LeftRightListProps extends LeftRightListContent, TopLevelTemplateComponentProps {
  tone?: keyof typeof Palette;
  editMode?: boolean;
  onUpdate?: (json: LeftRightListProps, focusElement?: string, selectAll?: boolean) => void;
  focusElement?: string;
  selectFocusedElement?: boolean;
  onModifyActionButtons?: (buttons: ActionButtonProps[], focusElement: string) => void;
}

export default function LeftRightList({
  id,
  heading,
  items = [],
  tone = 'tone1',
  footnotes,
  firstElement,
}: LeftRightListProps) {
  const border = Palette[tone].border ?? '';
  return (
    <StyledSection
      id={id}
      tone={tone}
      noSidePaddingFrom="xs"
      child
      noTopPadding={!firstElement}
      bottomSpacing={0}
      additionalClassName="content-management-item"
    >
      <StyledListWrapper sx={{ mb: '1.875rem' }}>
        <LeftRightListHeadingBlock heading={heading} tone={tone} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderTop: `1px solid ${border}`,
            borderBottom: footnotes?.length ? undefined : `1px solid ${border}`,
          }}
        >
          {items.map((item, index) => (
            <LeftRightListItemRow
              key={item.heading.id + index}
              item={item}
              index={index}
              tone={tone}
              paletteBorder={border}
              footnotes={footnotes}
            />
          ))}
          <FootnoteRenderer noTopMargin footnotes={footnotes} tone={tone} />
        </Box>
      </StyledListWrapper>
    </StyledSection>
  );
}
